import SocialProofLeft from '@/assets/icons/social-proof-left.svg?react';
import SocialProofRight from '@/assets/icons/social-proof-right.svg?react';
import {localize} from '@/shared/services/i18n';

const SocialProofLogo = () => (
  <div className="flex h-25 items-center text-center font-extrabold text-white">
    <SocialProofLeft className="mr-1 drop-shadow-logo" />
    <div>
      <p className="text-2xl drop-shadow-logo">35 000 000+</p>
      <p className="text-xl uppercase drop-shadow-logo">
        {localize('social_proof_downloads_label')}
      </p>
    </div>
    <SocialProofRight className="ml-1 drop-shadow-logo" />
  </div>
);

export default SocialProofLogo;
